import React from "react";

function AnalyticPref() {
  return <div>AnalyticPref</div>;
}

export default AnalyticPref;
